import { BarChart3, Package, Gift } from "lucide-react";

const features = [
  {
    icon: BarChart3,
    title: "Advanced Analytics",
    description: "Deep insights to optimize your operations",
    cta: "Learn more",
  },
  {
    icon: Package,
    title: "Inventory Management",
    description: "Track stock levels in real-time",
  },
  {
    icon: Gift,
    title: "Referral Program",
    description: "Refer a store and earn bonus rewards",
    cta: "Refer now",
  },
] as const;

export function LoginHero() {
  return (
    <div className="flex h-full max-w-lg flex-col justify-between">
      {/* Wordmark */}
      <div className="flex items-center gap-3">
        <img src="/logo.png" alt="XPOS" className="h-9 w-auto" />
      </div>

      {/* Main content */}
      <div className="-mt-8 flex flex-col gap-10">
        <div className="flex flex-col gap-5">
          <h1 className="text-[3.2rem] font-bold leading-[1.08] tracking-tight text-white xl:text-[3.6rem]">
            Point of Sale,
            <br />
            <span className="text-white/25">refined.</span>
          </h1>
          <p className="max-w-sm text-[0.95rem] leading-relaxed text-white/40">
            Everything you need to run your store — inventory, orders, and
            insights in one place.
          </p>
        </div>

        {/* Feature list */}
        <div className="flex flex-col">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="flex items-center gap-4 border-t border-white/[0.06] py-4 first:border-t-0"
            >
              <div className="flex size-9 shrink-0 items-center justify-center rounded-lg border border-white/[0.06] bg-white/[0.03]">
                <feature.icon className="size-4 text-white/40" />
              </div>
              <div className="flex-1">
                <p className="text-base font-medium text-white/70">
                  {feature.title}
                </p>
                <p className="text-sm text-white/30">{feature.description}</p>
              </div>
              {"cta" in feature && (
                <span className="shrink-0 text-sm font-medium text-white/30 hover:text-white/50 cursor-pointer transition-colors">
                  {feature.cta} →
                </span>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Trust line */}
      <p className="text-sm tracking-wide text-white/15">
        Trusted by retailers across the region
      </p>
    </div>
  );
}
